import qs from "qs";
import requestSC from "@/utils/requestSC";
import request from "@/utils/request";
import requestApi from "@/utils/requestApi";

// 自提人列表 https://sc.nxin.com/rest/member/self/list
export async function getSelfList(params = {}) {
  return requestApi.post("/scbasic/member/memberself/selList", params);
}

// 添加/编辑自提人 https://sc.nxin.com/rest/member/self/addOrEdit
// /
export async function updateSelf(params = {}) {
  return requestApi.post("/scbasic/member/memberself/add", params);
}
export async function memberselfEdit(params = {}) {
  return requestApi.post("/scbasic/member/memberself/edit", params);
}

// 删除自提人 https://sc.nxin.com/rest/member/self/del?id=1
export async function delSelf(params = {}) {
  console.log("params", params);
  return requestApi.post("/scbasic/member/memberself/del", params);
}

// 确认自提 order/credential_audit/sellerConfirmSelfPickUp
export async function confirmSelfPickUp(params = {}) {
  return requestSC.post("/mob/order/credential_audit/sellerConfirmSelfPickUp", params);
}

// 查看单卖家自提凭证审核 /mob/order/credential_audit/getSellerCredential
export async function getSellerCredential(params = {}) {
  return requestSC.get("/mob/order/credential_audit/getSellerCredential", {
    params
  });
}

// 查看运单详情 https://open.t.nxin.com/api/nxin.hl.ext.order.info/2.0
export async function getHLOrderInfo(params = {}) {
  return request.post("nxin.hl.ext.order.info/2.0", params);
}

// 确认自提前凭证校验
export async function confirmSelfPickUpData(params = {}) {
  return requestSC.post("/mob/order/credential_audit/validSellerConfirmSelfPickUpData", params);
}
